import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $j from 'jquery';
import classNames from 'classnames';
import listensToClickOutside from 'react-onclickoutside';
import showVideoResponse from 'helper/uppy/videoUploader';
import Icon from '../../helper/Icon';

const mp4VideoNote = {
  fontSize: '12px',
  color: 'var(--color-black1)',
  padding: '7px 0px 0px',
  display: 'block'
};

class VideoTransloaditUpload extends Component {
  static contextTypes = {
    showLoading: PropTypes.func,
    hideLoading: PropTypes.func,
    getFeatureFlag: PropTypes.func
  };

  constructor(props) {
    super(props);
    const blockId = this.props.blockItem._id;
    let uploading = false;
    let transcoding = false;
    if (window.blockUpload[blockId] && window.blockUpload[blockId].status === 'uploading') {
      uploading = true;
    }
    if (window.blockUpload[blockId] && window.blockUpload[blockId].status === 'transcoding') {
      transcoding = true;
    }
    this.state = {
      uploading,
      transcoding
    };
  }

  componentDidMount() {
    window.$ = $j;
  }

  handleClickOutside() {
    this.toggleMenu(false);
  }

  toggleMenu = show => {
    if (show) return $j('.VideoTransloaditUploadContainer .menu').addClass('menu--active');
    return $j('.VideoTransloaditUploadContainer .menu').removeClass('menu--active');
  };

  clickChildLabel = e => {
    $j(e.target)
      .find('label')
      .trigger('click');
  };

  videoUploaded = (type, r) => {
    type === 'video' && this.props.uploadDone(r.url, type);
    type === 'thumbnail' && this.props.uploadDone(r.url, type);
  };

  showFilePicker = type => () => {
    window.fs_filepicker = window.filestack && window.filestack.init('AuG7ZQSxaSemtziJGYwbsz');
    const self = this;
    this.context.showLoading();
    window.fs_filepicker
      .picker({
        fromSources: [
          'local_file_system',
          'url',
          'googledrive',
          'dropbox',
          'gmail',
          'video',
          'audio'
        ],
        accept: type === 'video' ? ['video/*'] : ['image/*'],
        maxFiles: 1,
        minFiles: 1,
        onOpen: () => {
          this.context.hideLoading();
        },
        onFileUploadFinished: data => {
          self.videoUploaded(type, data);
        }
      })
      .open();
  };

  renderImageOrStatus = src => {
    if (this.state.uploading) {
      return (
        <div className="upload">
          <strong className="upload__text">Uploading...</strong>
          {/* <button className="upload__action" onClick={this.cancelUpload}>Cancel</button> */}
        </div>
      );
    }
    if (this.state.transcoding) {
      return (
        <div className="upload">
          <strong className="upload__text">Transcoding video now...</strong>
          {/* <button className="upload__action" onClick={this.cancelUpload}>Cancel</button> */}
        </div>
      );
    }
    if (src && src.length > 0) {
      return [
        <div key={1} className="item-media__thumb-container">
          <figure
            className="item-media__thumb"
            style={{ backgroundImage: 'url(' + src + ')', backgroundSize: '100%' }}
          />
        </div>,
        <div key={2} className="item-media__name">
          <div className="item-media__text" />
        </div>
      ];
    }
    if (!src || src === '') {
      return (
        <div className="item-media__name">
          <div className="item-media__text-placeholder">
            Upload an image or video file, or embed something from the web.
          </div>
        </div>
      );
    }
  };

  renderMediaMenu = (src, srcAvailable) => {
    const buttonClass = classNames('menu__toggle', {
      'item-media__actions-link': srcAvailable,
      'item-media__icon item-media__icon-large': !srcAvailable
    });

    // console.log('pathUName:: ', pathUName);
    const blockId = this.props.blockItem._id;

    const useFilestackFilePicker =
      this.context.getFeatureFlag && this.context.getFeatureFlag('use-filestack');

    return (
      <div className="media-menu">
        <div className="menu">
          {!this.state.uploading && !this.state.transcoding && (
            <button className={buttonClass} onClick={this.toggleMenu}>
              Change
            </button>
          )}
          <div>
            <div className="menu__content menu__content--right menu__content">
              <div className="menu__listWrapper">
                <ul className="menu__list">
                  <li className="menu__item" onClick={this.clickChildLabel}>
                    <span>
                      <label
                        onClick={
                          useFilestackFilePicker
                            ? this.showFilePicker('video')
                            : () =>
                                showVideoResponse(
                                  blockId,
                                  data => this.videoUploaded('video', data),
                                  'video-upload'
                                )
                        }
                        className="button"
                      >
                        <span>
                          <span className="menu__icon">
                            <Icon
                              icon="file-upload-2"
                              size="15px"
                              viewBox="0 0 15 15"
                              fill="#313537"
                            />
                          </span>
                          {!srcAvailable ? 'Upload media' : 'Replace media'}
                        </span>
                      </label>
                    </span>
                  </li>
                  <li className="menu__item" onClick={this.clickChildLabel}>
                    <span>
                      <label
                        onClick={
                          useFilestackFilePicker
                            ? this.showFilePicker('thumbnail')
                            : () =>
                                showVideoResponse(
                                  blockId,
                                  data => this.videoUploaded('thumbnail', data),
                                  'picture-upload'
                                )
                        }
                        className="button"
                      >
                        <span>
                          <span className="menu__icon">
                            <Icon
                              icon="file-upload-2"
                              size="15px"
                              viewBox="0 0 15 15"
                              fill="#313537"
                            />
                          </span>
                          {!srcAvailable ? 'Upload thumbnail' : 'Replace thumbnail'}
                        </span>
                      </label>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // DISABLED adding these video types temporarily, video/x-m4v, video/webm, video/quicktime

  render() {
    const { videoUrl, thumbUrl } = this.props;
    const videoAvailable = videoUrl && videoUrl !== '' && videoUrl.length > 0;
    const clearnedThumbUrl = thumbUrl && thumbUrl.replace('wistiaInit:', '');
    return (
      <div className="VideoTransloaditUploadContainer">
        <div className="block-edit-field-embed">
          <div className="item-media__row">
            {this.renderImageOrStatus(clearnedThumbUrl)}
            {this.renderMediaMenu(this.props.src, videoAvailable)}
          </div>
        </div>
      </div>
    );
  }
}

export default listensToClickOutside(VideoTransloaditUpload);
